<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="400px">
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("printBatchOfLogs") }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-container fluid>
                    <v-text-field
                        class=""
                        v-model="logsAmount"
                        :label="$t('logsAmount')"
                        :rules="[rules.required, rules.number]"
                        autofocus
                        required
                    ></v-text-field>
                    <v-checkbox
                        v-model="useSawWaste"
                        :label="$t('sawWaste')"
                        hide-details
                    ></v-checkbox>
                    <v-checkbox
                        v-model="useRawMaterials"
                        :label="$t('rawMaterials')"
                        hide-details
                    ></v-checkbox>
                </v-container>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="setAnswer(true)">{{ $t("print") }}</v-btn>
                    <v-btn color="error" @click="setAnswer(false)">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        name: "PatternPrintParamsDialog",

        data () {
            return {
                dialog: false,
                logsAmount: 1,
                useSawWaste: true,
                useRawMaterials: true,
                answer: null,

                rules: {
                    required:  value => !!value || this.$t("requiredField"),
                    number:    value => (value >= 1 && value <= 999999) || this.$t("incorrectValue"),
                },
            }
        },

        watch: {
            dialog (val) {
                if (val) {
                    this.answer = null;
                    this.value = 1;
                }
            }
        },

        methods: {
            setAnswer (val) {
                this.answer = val;
                this.dialog = false;
            }
        }
    }
</script>
